/**
 * Copyright (c) 2022 Animation Studio Voronezh.
 *
 * CONFIDENTIAL AND PROPRIETARY
 *
 * This work is provided "AS IS" and subject to the Prodtrack
 * Source Code License. By accessing, using, copying or modifying
 * this work you indicate your agreement to the Prodtrack Source Code License.
 * All rights not expressly granted therein are reserved by Animation Studio Voronezh.
 */

import React from "react";
import { Dimmer, Loader } from "semantic-ui-react";

const AuthenticatingOverlay = ({ active }) => (
    <Dimmer active={active} page>
        <Loader size="large">
            Signing you in...
            <div style={{ fontSize: "0.85em", marginTop: "10px" }}>
                Waiting for the authentication provider. Please do not close
                this page.
            </div>
        </Loader>
    </Dimmer>
);

export default AuthenticatingOverlay;
